import { createFileRoute } from '@tanstack/react-router';
import { GruposPage } from '@/components/gestao-grupos';

export const Route = createFileRoute('/_app/configuracoes/grupos')({
  component: GruposPage,
});
